enum SubscriptionProviderType {
  INTERNAL = 'Internal',
  EXTERNAL = 'External',
}

export default SubscriptionProviderType;
